import styled from 'styled-components'

export const CheckboxWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  a {
    color: ${({ theme }) => theme.colors.brand.orange};
    text-decoration: none;
  }
`
